module.exports = __webpack_public_path__ + "static/media/icon_chevron_middle.3a6b6c6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Stepper/assets/icon_chevron_middle.svg
// module id = 1502
// module chunks = 193